module.exports = __webpack_public_path__ + "media/images/admin2/Button--icon-plus-1dbe2d54e421a82c19190137ff0c6a75.svg";